import { ADMIN_STATE_KEY } from "~/admin";
import { STEERING_DATA_KEY, ISteeringDataState } from "./reducer";

const getModuleState = (state): ISteeringDataState => state[ADMIN_STATE_KEY][STEERING_DATA_KEY];

export const getSteeringDataRecords = (state) => getModuleState(state).records;
export const getSelectedSteeringDataRecord = (state) => getModuleState(state).selectedRecord;
export const getSteeringDataLoading = (state) => getModuleState(state).loading;
export const getSteeringDataError = (state) => getModuleState(state).error;
